module.exports = __webpack_public_path__ + "static/media/citrus_color_black.40063809.svg";